import React, { useState } from "react"
import "./brands.sass"
import { Slider, window } from "../../utils"

import Pic1 from "../../images/partner/0219/churchs.png"
import Pic2 from "../../images/partner/0219/zhouheiya.png"
import Pic3 from "../../images/partner/0219/yuanji.png"
import Pic5 from "../../images/partner/0219/subway.png"
import Pic4 from "../../images/partner/0219/pinweichangan.png"
import Pic6 from "../../images/partner/0219/najiaxiaoguan.png"
import Pic7 from "../../images/partner/0219/hongxing.png"
import Pic8 from "../../images/partner/0219/haidilao.png"
import Pic9 from "../../images/partner/0219/fuxiaojie.png"
import Pic10 from "../../images/partner/0219/duke.png"
import Pic11 from "../../images/partner/liuyishou@2x.png"
import Pic12 from "../../images/partner/0219/dongpo.png"
import Pic13 from "../../images/partner/0219/jiyajia.jpg"
import Pic14 from "../../images/partner/0219/huanghou.jpg"
import Pic15 from "../../images/partner/0219/kungfucha.jpg"
import Pic16 from "../../images/partner/0219/yifang.png"
import Pic17 from "../../images/partner/0219/buerjia.png"
import Pic18 from "../../images/partner/0219/xianyuxian.jpg"

const SliderList = [
  Pic8,
  Pic10,
  Pic1,
  Pic12,
  Pic13,
  Pic11,
  Pic5,
  Pic2,
  Pic3,
  Pic4,
  Pic5,
  Pic6,
  Pic7,
  Pic8,
  Pic9,
  Pic10,
  Pic11,
  Pic12,
  Pic13,
  Pic14,
  Pic15,
  Pic16,
  Pic17,
  Pic18,
]

const MobileVersion = () => {
  return (
    <div className="partner-brands">
      <div className="container">
        <div className="columns is-mobile">
          {SliderList.map((slider, index) => {
            return (
              <div className="column is-one-quarter slide-item" key={index}>
                <div className="imgbox" style={{ backgroundImage: `url(${slider})` }} />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default () => {
  const [isMobile, setIsMobile] = useState(window.isMobile())
  const SliderSettings = {
    dots: false,
    infinite: true,
    speed: 1500,
    autoplay: true,
    autoplaySpeed: 1000, // 鼠标移过停止播放
    slidesToShow: isMobile ? 4 : 7,
    slidesToScroll: isMobile ? 4 : 1,
    afterChange: cur => {
      console.log(cur === SliderList.length - 1)
    },
  }

  return (
    <div className="partner-brands">
      <div className="container">
        <Slider {...SliderSettings}>
          {SliderList.map((slider, index) => {
            return (
              <div className="slide-item" key={index}>
                <div className="imgbox" style={{ backgroundImage: `url(${slider})` }} />
              </div>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}
